import { getCustomisationValue } from "../../EditablePreview";

const SubbombBg = (props) => {
    // console.log("NaturalSizeImageBG props:", props);
    const customisationVars = props.node.customisationVars;
    const scaledBgScale = (getCustomisationValue(customisationVars, 'customImageOverlay.backgroundImage.image.scale', props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? 100) / 100;
    const tileBg = getCustomisationValue(customisationVars, 'customImageOverlay.backgroundImage.image.tileImage', props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? false;

    const ScaledBg = (props) => {
        const nodeModules = props.node?.config?.children ?? [];
        let imageBgModule = null;
        for (let i = 0; i < nodeModules.length; i++) {
            if (nodeModules[i].module === 'fill') {
                imageBgModule = nodeModules[i];
                break;
            }
        }
        if (!imageBgModule) {
            return null;
        }
        let typeField = null;
        for (let i = 0; i < imageBgModule?.fields?.length; i++) {
            if (imageBgModule.fields[i].field === 'customisation-module-fill-type') {
                typeField = imageBgModule.fields[i];
                break;
            }
        }
        if (!typeField) {
            return null;
        }
        const imageDataLink = typeField?.["customisation-module-fill-type-image"]?.options?.["customisation-module-fill-type-image-options-image"]?.dataLink ?? null;
        if (!imageDataLink) {
            return null;
        }
        const imageData = getCustomisationValue(customisationVars, imageDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
        if (!imageData || typeof imageData !== 'object' || !imageData.srcUrl) {
            return null;
        }

        const imageStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) scale(' + props.previewScale * (scaledBgScale ?? 1) + ')',
        }

        return (
            <img style={imageStyle} src={imageData.srcUrl} alt="Scaled Background" />
        );
    }

    const TiledBg = (props) => {
        const nodeModules = props.node?.config?.children ?? [];
        let imageBgModule = null;
        for (let i = 0; i < nodeModules.length; i++) {
            if (nodeModules[i].module === 'fill') {
                imageBgModule = nodeModules[i];
                break;
            }
        }
        if (!imageBgModule) {
            return null;
        }
        let typeField = null;
        for (let i = 0; i < imageBgModule?.fields?.length; i++) {
            if (imageBgModule.fields[i].field === 'customisation-module-fill-type') {
                typeField = imageBgModule.fields[i];
                break;
            }
        }
        if (!typeField) {
            return null;
        }
        const imageDataLink = typeField?.["customisation-module-fill-type-image"]?.options?.["customisation-module-fill-type-image-options-image"]?.dataLink ?? null;
        if (!imageDataLink) {
            return null;
        }
        const imageData = getCustomisationValue(customisationVars, imageDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
        if (!imageData || typeof imageData !== 'object' || !imageData.srcUrl) {
            return null;
        }

        const tiledBgStyle = {
            width: 1920,
            height: 1080,
            backgroundImage: `url(${imageData.srcUrl})`,
            backgroundRepeat: 'repeat',
            backgroundSize: 'auto',
            backgroundPosition: 'center',
            transform: 'scale(' + props.previewScale + ')',
            transformOrigin: 'top left',
            marginLeft: -2,
            marginTop: -2,
        }

        return (
            <div style={{ width: '100%', height: '100%', overflow: 'visible' }}>
                <div style={tiledBgStyle}></div>
            </div>
        )
    }

    return (
        <>
            {tileBg ? <TiledBg {...props} /> : <ScaledBg {...props} />}
        </>
    );
}

export default SubbombBg;
